import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from '../common/Icon'
import FontNumber from '../common/FontNumber'
import { EXPLORER_URL } from '../../utils/httpRequest'

const Loading = styled.div`
  color: #f0b90b;
  display: flex;
  line-height: 16px;
  span {
    margin-left: 5px;
  }
`

const Text = styled.a`
  display: block;
  color: ${props => props.theme.TxHashColor};
  text-decoration: underline;
  width: ${props => (props.width ? props.width : '150px')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &:hover {
    color: #f0b90b;
  }
`

class TxHash extends PureComponent {
  static propTypes = {
    hash: PropTypes.string,
    width: PropTypes.string,
  }

  static defaultProps = {
    hash: '',
    width: '',
  }

  render() {
    const { hash, width } = this.props
    return (
      <div>
        {hash ? (
          <Text width={width} href={`${EXPLORER_URL}/tx/${hash}`} target="_blank">
            <FontNumber value={hash} />
          </Text>
        ) : (
          <Loading>
            <Icon type="loading" size="14" />
            <span>Pending</span>
          </Loading>
        )}
      </div>
    )
  }
}

export default TxHash
